import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { Box } from '@mui/material';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useCustomStickyElement } from './hooks';
import { useCreditCardsMultiCompareContext } from './provider';
export const HorizontalScrollIndicator: React.FC = () => {
  const $ = _c(15);
  const [isScrollable, setIsScrollable] = useState(false);
  const {
    containerRef
  } = useCreditCardsMultiCompareContext();
  const targetRef = useRef(null);
  const [display, setDisplay] = useState(true);
  let t0;
  if ($[0] !== containerRef) {
    t0 = {
      containerRef,
      targetRef,
      offsetBottom: 150,
      targetTop: 380
    };
    $[0] = containerRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useCustomStickyElement(t0);
  let t1;
  let t2;
  if ($[2] !== containerRef) {
    t1 = () => {
      let resizeObserver = null;
      let rafId = null;
      let container = null;
      let scrollFn = null;
      rafId = requestAnimationFrame(() => {
        const currentContainer = containerRef?.current;
        if (!currentContainer) {
          return;
        }
        container = currentContainer;
        const checkScrollable = () => {
          if (!container) {
            return;
          }
          const scrollable = container.scrollWidth - container.clientWidth >= 60;
          setIsScrollable(scrollable);
        };
        resizeObserver = new ResizeObserver(checkScrollable);
        resizeObserver.observe(container);
        checkScrollable();
        scrollFn = () => {
          setDisplay(false);
        };
        container.addEventListener("scroll", scrollFn, {
          passive: true
        });
      });
      return () => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }
        resizeObserver?.disconnect();
        if (container && scrollFn) {
          container.removeEventListener("scroll", scrollFn);
        }
      };
    };
    t2 = [containerRef];
    $[2] = containerRef;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== isScrollable) {
    t3 = !isScrollable && {
      display: "none"
    };
    $[5] = isScrollable;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== display) {
    t4 = !display && {
      opacity: 0
    };
    $[7] = display;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      position: "absolute",
      right: "1rem",
      transform: "translateY(50%)",
      zIndex: -1,
      transition: "opacity 0.3s ease-out",
      ...t3,
      ...t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src={`${env.NEXT_PUBLIC_NW_URL}cdn/structured-content/horizontal-scroll-indicator.svg`} alt="Horizontal scroll" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <Box ref={targetRef} sx={t5}>{t6}</Box>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};